var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEobStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.65593 21.5C1.46604 21.5 0.498047 20.5322 0.498047 19.3424V8.43248C0.498047 8.15595 0.6299 7.88907 0.855015 7.72508L3.70754 5.63826V3.94051C3.70754 3.4582 4.09988 3.06592 4.58227 3.06592H7.21612L10.4835 0.667203C10.6346 0.557878 10.8115 0.5 10.998 0.5C11.1846 0.5 11.3614 0.557878 11.5126 0.667203L14.7832 3.06592H17.417C17.8994 3.06592 18.2918 3.4582 18.2918 3.94051V5.63826L21.1443 7.72508C21.3694 7.88907 21.5045 8.15273 21.5013 8.43248V19.3424C21.5013 20.5322 20.5333 21.5 19.3434 21.5H2.65593ZM2.2443 19.3424C2.2443 19.5675 2.4276 19.754 2.65593 19.754H19.3434C19.5685 19.754 19.755 19.5707 19.755 19.3424V9.9791L11.4322 14.963C11.3003 15.0402 11.1492 15.0788 10.9948 15.0788C10.8405 15.0788 10.6893 15.037 10.5575 14.963L2.24751 9.9791V19.3424H2.2443ZM10.998 13.1881L16.5423 9.86334V4.81511H5.45379V9.86334L10.998 13.1881ZM3.70754 8.82154V7.80547L2.94537 8.36174L3.70754 8.82154ZM18.2886 8.81511L19.0507 8.36174L18.2886 7.80547V8.81511ZM11.831 3.06913L10.998 2.4582L10.1651 3.06913H11.831Z",
    fill: "#63C0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEobStatus);
export default __webpack_public_path__ + "static/media/eob-status.85a7d7955769c71e358c54a566383838.svg";
export { ForwardRef as ReactComponent };